module.exports = __webpack_public_path__ + "img/RBS_event_02_loading.bc57f51f.png";